import { render } from "./PopUp.vue?vue&type=template&id=44220894"
import script from "./PopUp.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./PopUp.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script